import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import Sound from "react-sound";
import {
  call,
  cancelCall,
  endCall,
  acceptCall as answer,
  sendMessage as sendTxt,
  rejectCall as reject,
  muteAudio,
  muteVideo,
  muteRemoteAudio,
  stopRemoteAudio,
  stopVideo,
  stopAudio,
} from "../actions/sipActions";
import { unBindLocalStream } from "../actions/configActions";
import ActionTypes from "../actions/actionTypes";
import { CALL_STATE } from "../reducers/sipReducer";
import DialerView from "./DialerView";
import RealTimeText from "../components/RealTimeText";
import AudioVideo from "../components/AudioVideo";
import RoundRejectButton from "../components/buttons/RoundRejectButton";
import RoundAnswerButton from "../components/buttons/RoundAnswerButton";
import InCallButtonBar from "../components/InCallButtonBar";
import "./InCall.css";
import icon from "../branding/current/icon.png";
import logo from "../branding/current/logo.png";
import logoDark from "../branding/current/logo_dark.png";

class InCall extends React.Component {
  currentNotification = null;
  lastNotificationMissedCall = false;
  sameCall = false;
  inCallAlready = false;
  knockKnockActive = false;

  stillInCall = e => {
    e.preventDefault();
    e.returnValue =
      "You are in a call. Are you sure that you want to exit the page?"; //there is a default dialog text for new browsers that is shown instead
    return "You are in a call. Are you sure that you want to exit the page?"; //there is a default dialog text for new browsers that is shown instead
  };

  keyPress = e => {
    if (
      this.props.callState === CALL_STATE.INCOMING_CALL &&
      (e.keyCode === 13 || e.keyCode === 0 || e.keyCode === 32)
    ) {
      this.props.answer();
      e.preventDefault();
    }
  };

  componentDidMount() {
    window.addEventListener("beforeunload", this.stillInCall);
    window.addEventListener("resize", this.adjustVideoSize.bind(this));
    window.addEventListener("keypress", this.keyPress.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.stillInCall);
    window.removeEventListener("resize", this.adjustVideoSize.bind(this));
    window.removeEventListener("keypress", this.keyPress.bind(this));
    this.props.unBindLocalStream();
  }

  createNotificationCalling = () => {
    this.lastNotificationMissedCall = false;
    var from =
      this.props.callB === ""
        ? this.props.l10n("call.unknownnumber")
        : this.props.callB;
    var title = this.props.l10n("call.incoming") + from;
    var body = this.props.l10n("call.notificationbody");
    this.sameCall = true;
    var answer = this.props.answer;
    //var reject = this.props.reject;

    if (window.Notification && Notification.permission === "granted") {
      var notiIcon = icon ? icon : null;

      this.currentNotification = new Notification(title, {
        body: body,
        icon: notiIcon,
        requireInteraction: true,
        vibrate: [200, 100, 200, 100, 200, 100, 400],
      });

      this.currentNotification.onclick = function(event) {
        answer();
        window.focus();
        this.close();
        this.currentNotification = null;
      };
    }
  };

  createNotificationMissedCall = () => {
    var from =
      this.props.callB === ""
        ? this.props.l10n("call.unknownnumber")
        : this.props.callB;
    var title = this.props.l10n("common.missedcall") + " " + from;
    this.lastNotificationMissedCall = true;
    this.sameCall = false;

    if (window.Notification && Notification.permission === "granted") {
      var notiIcon = icon ? icon : null;

      this.currentNotification = new Notification(title, {
        icon: notiIcon,
        requireInteraction: true,
        vibrate: [200, 100, 200, 100, 200, 100, 400],
      });

      this.currentNotification.onclick = function(event) {
        window.focus();
        this.close();
        this.currentNotification = null;
      };
    }
  };

  closeNotification = () => {
    if (this.currentNotification !== null) {
      this.currentNotification.close();
      this.currentNotification = null;
    }
  };

  adjustVideoSize() {
    if (this.props.videoavailable) {
      if (this.props.videoVisible) {
        setTimeout(() => {
          $("#videoContainer").width($("#remote-video").width() + "px");
          $("#remote-video-container").width($("#remote-video").width() + "px");
          if (this.props && this.props.browser.name === "ie") {
            $(".inCallTextContainer").width(
              $(window).width() - $("#videoContainer").width() + "px"
            );
          }
        }, 50);
      } else {
        $("#videoContainer").width("0px");
        $("#remote-video-container").width("0px");
        if (this.props && this.props.browser.name === "ie") {
          $(".inCallTextContainer").width($(window).width() + "px");
        }
      }
    }
  }

  stopKnockKnock() {
    setTimeout(() => {
      this.props.stopKnockKnock();
      this.knockKnockActive = false;
    }, 5000);
  }

  render() {
    switch (this.props.callState) {
      case CALL_STATE.INCOMING_CALL:
        return this.standard(this.incoming, true);
      case CALL_STATE.CALLING:
        return this.standard(this.outgoing, false);
      case CALL_STATE.REJECTED_LOCAL:
      case CALL_STATE.CANCELED_LOCAL:
      case CALL_STATE.TERMINATED_LOCAL:
        //will not happen
        break;
      case CALL_STATE.ESTABLISHING:
        return this.standard(this.establishing, false);
      case CALL_STATE.CANCELED_REMOTE:
        return this.standard(this.canceled_remote, false);
      case CALL_STATE.TERMINATED_REMOTE:
        return this.standard(this.terminated_remote, false);
      case CALL_STATE.REJECTED_REMOTE:
        return this.standard(this.rejected_remote, false);
      case CALL_STATE.FAILED:
        return this.standard(this.unknown_error, false);
      case CALL_STATE.ACCEPTED:
        return this.incall();
      default:
        break;
    }
    return <div>Unknown call status {this.props.callStatus}</div>;
  }

  rejectCall = () => {
    this.closeNotification();
    this.props.reject();
  };

  incoming = () => {
    if (this.sameCall === false) {
      this.createNotificationCalling();
    }

    var from =
      this.props.callB === ""
        ? this.props.l10n("call.unknownnumber")
        : this.props.callB;

    var signal =
      this.props.ringsignals[0].value === this.props.signal
        ? this.props.ringsignals[0].audio
        : this.props.ringsignals[1].value === this.props.signal
        ? this.props.ringsignals[1].audio
        : this.props.ringsignals[2].value === this.props.signal
        ? this.props.ringsignals[2].audio
        : this.props.ringsignals[3].value === this.props.signal
        ? this.props.ringsignals[3].audio
        : this.props.ringsignals[4].audio;

    return (
      <div className={"text-align-center margin-auto"}>
        <h1>{this.props.l10n("call.incoming") + " " + from}</h1>
        <div className={"row text-align-center margin-auto"}>
          <div className={"col"}>
            <RoundAnswerButton
              text={this.props.l10n("common.answer")}
              onClick={() => this.props.answer()}
            />
          </div>
          <div className={"col"}>
            <RoundRejectButton
              text={this.props.l10n("common.reject")}
              onClick={() => this.rejectCall()}
              kioskmode={false}
            />
          </div>
        </div>
        <Sound url={signal} playStatus={Sound.status.PLAYING} loop={true} />
      </div>
    );
  };

  outgoing = () => {
    var contactName = this.props.callBName;

    return (
      <div className={"text-align-center margin-auto"}>
        <h1>{this.props.l10n("common.calling") + " " + contactName}</h1>
        <br />
        <RoundRejectButton
          text={this.props.l10n("common.cancel")}
          onClick={() => this.props.cancel()}
          kioskmode={false}
        />
      </div>
    );
  };

  canceled_remote = str => {
    this.sameCall = false;

    if (
      window.Notification &&
      Notification.permission === "granted" &&
      this.lastNotificationMissedCall === false
    ) {
      this.closeNotification();
      this.createNotificationMissedCall();
    }

    this.props.complete();
  };

  establishing = () => {
    return (
      <div className={"text-align-center margin-auto"}>
        <h1>{this.props.l10n("call.establishing")}</h1>
        <div className="spinner">
          <div className="rect1"></div>
          <div className="rect2"></div>
          <div className="rect3"></div>
          <div className="rect4"></div>
          <div className="rect5"></div>
          <div className="rect6"></div>
          <div className="rect7"></div>
        </div>
      </div>
    );
  };

  terminated_remote = str => {
    this.inCallAlready = false;
    this.sameCall = false;
    var contactName = this.props.callBName;
    contactName =
      contactName === "" || contactName === undefined
        ? this.props.l10n("call.unknownnumber_uppercase")
        : contactName;
    return (
      <div className={"text-align-center margin-auto"}>
        <h1>
          {contactName} {this.props.l10n("call.endedcall")}
        </h1>
        <br />
        <div className={"row text-align-center margin-auto"}>
          <div className={"col"}>
            <RoundAnswerButton
              text={this.props.l10n("common.callback")}
              onClick={() => this.props.call(this.props.callB)}
            />
          </div>
          <div className={"col"}>
            <RoundRejectButton
              text={this.props.l10n("common.cancel")}
              onClick={() => this.props.complete()}
              kioskmode={false}
            />
          </div>
        </div>
      </div>
    );
  };

  unknown_error = str => {
    this.inCallAlready = false;
    this.sameCall = false;
    return (
      <div className={"text-align-center margin-auto"}>
        <h1>{this.props.l10n("error.unknown")}</h1>
        <br />
        <div className={"row text-align-center margin-auto"}>
          <div className={"col"}>
            <RoundAnswerButton
              text={this.props.l10n("common.callback")}
              onClick={() => this.props.call(this.props.callB)}
            />
          </div>
          <div className={"col"}>
            <RoundRejectButton
              text={this.props.l10n("common.cancel")}
              onClick={() => this.props.complete()}
              kioskmode={false}
            />
          </div>
        </div>
      </div>
    );
  };

  rejected_remote = str => {
    this.closeNotification();
    this.sameCall = false;
    var contactName = this.props.callBName;

    return (
      <div className={"text-align-center margin-auto"}>
        <h1>
          {contactName} {this.props.l10n("call.rejected")}
        </h1>
        <br />
        <div className={"row text-align-center margin-auto"}>
          <div className={"col"}>
            <RoundAnswerButton
              text={this.props.l10n("common.callagain")}
              onClick={() => this.props.call(this.props.callB)}
            />
          </div>
          <div className={"col"}>
            <RoundRejectButton
              text={this.props.l10n("common.cancel")}
              onClick={() => this.props.complete()}
              kioskmode={false}
            />
          </div>
        </div>
      </div>
    );
  };

  incall = () => {
    if (this.inCallAlready === false) {
      this.inCallAlready = true;
    }
    if (this.knockKnockActive === false) {
      this.stopKnockKnock();
      this.knockKnockActive = true;
    }
    this.adjustVideoSize();
    $("#remote-video").resize(() => {
      this.adjustVideoSize();
    });

    this.closeNotification();

    var smallScreenMode = window.innerWidth < 992 ? true : false;
    var videoIsVisible =
      this.props.videoavailable && (!smallScreenMode || this.props.videoMode);
    var textIsVisible =
      this.props.textavailable &&
      this.props.textVisible &&
      (!smallScreenMode || !videoIsVisible);
    if (this.props.video && !this.props.videoavailable) {
      this.props.stopVideo();
    }
    if (this.props.audio && !this.props.audioavailable) {
      this.props.stopAudio();
      this.props.stopRemoteAudio();
    }

    //
    // Height will be 100vh except for iOS devices where the height must be adjusted for the view to
    // look good. Otherwise the view will scroll when the soft keyboard is shown and hide the footer
    // or header buttons.
    //
    return (
      <div className="callFullscreen">
        <div
          className={
            "box callContainer " +
            (this.props.knockKnock ? "flash " : "") +
            (this.props.browser.os === "iOS"
              ? "height-IOS"
              : "height-100-procent") +
            (!this.props.videoVisible && !this.props.textVisible ? "" : "")
          }
        >
          {!this.props.videoVisible && !this.props.textVisible && (
            <p className="margin-auto">
              {this.props.l10n("call.videoTextDisabled")}
            </p>
          )}

          <main
            role={"main"}
            className={
              "content callViewContainer" +
              (this.props.videoVisible || this.props.textVisible
                ? ""
                : "display-none")
            }
          >
            <h1 style={{ display: "none" }}>
              {this.props.l10n("aria.in-call")}
            </h1>
            <div
              id={"videoContainer"}
              ref={n => (this.node1 = n)}
              className={
                "inCallVideoContainer" + (videoIsVisible ? "" : " display-none")
              }
            >
              <AudioVideo
                isVisible={this.props.videoVisible}
                isVideoAvailable={this.props.videoavailable}
                direction="remote"
                kioskmode={false}
                textIsVisible={textIsVisible}
              />
              <AudioVideo
                isVisible={this.props.selfViewVisible}
                isVideoAvailable={this.props.videoavailable}
                direction="local"
                kioskmode={false}
              />
            </div>
            {this.props.text_enabled && (
              <div
                ref={n => (this.node2 = n)}
                className={
                  "padding-zero inCallTextContainer" +
                  (textIsVisible ? "" : " display-none")
                }
              >
                <RealTimeText
                  isVisible={this.props.textVisible}
                  layout={this.props.textLayout}
                  text={this.props.text}
                  colors={this.props.colors}
                  font={this.props.font}
                  sendTxt={this.props.sendTxt}
                  kioskmode={false}
                  placeholderCombined={this.props.l10n("call.writeHere")}
                  placeholderOutgoing={this.props.l10n("call.writeHere")}
                  placeholderIncoming={this.props.l10n("call.receiveHere")}
                />
              </div>
            )}
          </main>
          <DialerView />
          <InCallButtonBar
            l10n={this.props.l10n}
            isAudioAvailable={this.props.audioavailable}
            isVideoAvailable={this.props.videoavailable}
            isTextAvailable={this.props.textavailable}
            isDialpadAvailable={this.props.dialpadavailable}
            isVideoVisible={this.props.videoVisible}
            isTextEnabled={this.props.text_enabled}
            isSoundOn={this.props.soundOn}
            isTextVisible={this.props.textVisible}
            isDialerVisible={this.props.dialerVisible}
            isSelfViewVisible={this.props.selfViewVisible}
            videoMode={this.props.videoMode}
            unreadText={this.props.unreadText}
            audio={this.props.audio}
            video={this.props.video}
            hangup={() => this.props.hangup()}
            muteAudio={() => this.props.muteAudio()}
            muteVideo={() => this.props.muteVideo()}
            muteRemoteAudio={() => this.props.muteRemoteAudio()}
            hideVideo={() => this.props.hideVideo()}
            hideText={() => this.props.hideText()}
            hideDialer={() => this.props.hideDialer()}
            hideSelfview={() => this.props.hideSelfview()}
            kioskmode={false}
            smallScreenMode={smallScreenMode}
            show={this.props.show}
            showMore={() => this.props.showMore()}
            toggleVideoMode={() => this.props.toggleVideoMode()}
          />
        </div>
      </div>
    );
  };

  standard = (include, flash) => {
    return (
      <div className="callFullscreen">
        <header className="inCallHeader branding-header">
          <img
            className="logo"
            src={this.props.contrast ? logoDark : logo}
            alt={this.props.l10n("menu.logo")}
          />
        </header>
        <div className="box callContainer">
          <main
            className={
              "row content margin-0_1em call-center " + (flash ? "flash" : "")
            }
          >
            {include()}
          </main>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => {
  return {
    websocket: state.connection.websocket,
    text: {
      in: state.call.text_in,
      out: state.call.text_out,
      combined: state.call.text_combined,
    },
    unreadText: state.call.text_unread,
    callB: state.call.callB,
    callBName: state.call.callBName,
    callState: state.sip.callState,
    contacts: state.contact.contacts,
    services: state.service.services,
    font: {
      size: state.setting.user.WEB_TEXT_SIZE,
      family: state.setting.user.WEB_FONT,
    },
    colors: {
      background: state.setting.user.WEB_ONEBOX_TEXT_BACKGROUND_COLOR,
      foreground: state.setting.user.WEB_ONEBOX_TEXT_COLOR,
      in: {
        foreground: state.setting.user.WEB_TEXT_IN_COLOR,
        background: state.setting.user.WEB_TEXTAREA_IN_BACKGROUND,
      },
      out: {
        foreground: state.setting.user.WEB_TEXT_OUT_COLOR,
        background: state.setting.user.WEB_TEXTAREA_OUT_BACKGROUND,
      },
    },
    textLayout: state.setting.user.WEB_CHAT_LAYOUT,
    l10n: state.config.text,
    audioavailable: state.call.audioavailable && state.sip.negotiated.audio,
    videoavailable: state.call.videoavailable && state.sip.negotiated.video,
    textavailable: state.call.textavailable && state.sip.negotiated.text,
    dialpadavailable: state.config.mode.dialpad,
    audio: state.call.audio,
    video: state.call.video,
    videoVisible: state.call.videoVisible,
    textVisible: state.call.textVisible,
    text_enabled: state.config.mode.safetext,
    videoMode: state.call.videoMode,
    soundOn: state.call.soundOn,
    dialerVisible: state.call.dialerVisible,
    selfViewVisible: state.call.selfViewVisible,
    show: state.call.showMore,
    browser: state.config.browser,
    contrast: state.accessibility.isHighContrast,
    ringsignals: state.config.ringsignals,
    signal: state.setting.user.WEB_RINGTONE,
    knockKnock: state.call.knockknock,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    call: to => {
      return dispatch(call(to));
    },
    cancel: () => {
      return dispatch(cancelCall());
    },
    hangup: () => {
      return dispatch(endCall());
    },
    answer: () => {
      return dispatch(answer());
    },
    reject: () => {
      return dispatch(reject());
    },
    complete: () => {
      return dispatch({
        type: ActionTypes.SIP_CALL_COMPLETED,
      });
    },
    sendTxt: str => {
      return dispatch(sendTxt(str));
    },
    muteAudio: () => {
      return dispatch(muteAudio());
    },
    muteVideo: () => {
      return dispatch(muteVideo());
    },
    stopAudio: () => {
      return dispatch(stopAudio());
    },
    stopVideo: () => {
      return dispatch(stopVideo());
    },
    muteRemoteAudio: () => {
      return dispatch(muteRemoteAudio());
    },
    stopRemoteAudio: () => {
      return dispatch(stopRemoteAudio());
    },
    hideVideo: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_VIDEO,
      });
    },
    hideText: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_TEXT,
      });
    },
    hideDialer: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_DIALER,
      });
    },
    hideSelfview: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_SELFVIEW,
      });
    },
    showMore: () => {
      return dispatch({
        type: ActionTypes.CALL_SHOW_MORE,
      });
    },
    toggleVideoMode: () => {
      return dispatch({
        type: ActionTypes.CALL_TOGGLE_VIDEO_MODE,
      });
    },
    unBindLocalStream: () => {
      return dispatch(unBindLocalStream());
    },
    stopKnockKnock: () => {
      return dispatch({
        type: ActionTypes.CALL_KNOCK_KNOCK,
        payload: false,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InCall);






// WEBPACK FOOTER //
// ./src/containers/InCall.js